// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../node_modules/rescript/lib/es6/list.js";
import * as $$String from "../../../../node_modules/rescript/lib/es6/string.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Caml_string from "../../../../node_modules/rescript/lib/es6/caml_string.js";

function omit_plural(gift) {
  var length = gift.length;
  if (Caml_string.get(gift, length - 1 | 0) === /* 's' */115) {
    return $$String.sub(gift, 0, length - 1 | 0);
  } else {
    return gift;
  }
}

function capitalizeGiftNames(gift) {
  return $$String.concat(" ", List.map($$String.capitalize_ascii, $$String.split_on_char(/* ' ' */32, omit_plural(gift))));
}

function removeSymbolsFromString(input, symbols) {
  return Belt_Array.reduce(symbols, input, (function (acc, symbol) {
                return acc.replace(new RegExp(symbol), "");
              }));
}

export {
  omit_plural ,
  capitalizeGiftNames ,
  removeSymbolsFromString ,
  
}
/* No side effect */
